import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class QualityService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets quality
     * @author Starley Cazorla
     * @param cpf
     * @returns
     */
    async getQuality(cpf: any) {
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);

                this.httpService.get(UrlConnectionEnum.GET_QUALITY_LIST, { cpf: cpf }, config).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });

            } catch (error) {
                reject(error);
            }
        });
    }
}
